import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useRoundingRulesQuery } from './useRoundingRulesQuery';
import { useRoundingRulesTableState } from './useRoundingRulesTableState';

export const useRoundingRulesTable = () => {
    const { t } = useTranslation();
    const { rows, setRows, loading, setLoading, loadData } = useRoundingRulesQuery();
    const { contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected } = useRoundingRulesTableState();

    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: t('settings.rounding_rule.table.columns.name'),
            flex: 1,
        },
        {
            field: 'description',
            headerName: t('settings.rounding_rule.table.columns.description'),
            flex: 3,
        },
    ];

    const reloading = useCallback(() => {
        const permissions = JSON.parse(localStorage.getItem('permissions') || '[]') as string[];
        const canReadRoundingRules = permissions.includes('timekeeper.RoundingRules');

        if (canReadRoundingRules) {
            loadData().finally(() => {
                setContextMenu(null);
                cleanSelected();
            });
        } else {
            setRows([]);
            setLoading(false);
        }
    }, [cleanSelected, loadData, setContextMenu, setLoading, setRows]);

    return {
        rows,
        loading,
        loadData,
        reloading,
        selectedRow,
        setSelectedRow,
        contextMenu,
        setContextMenu,
        selected,
        setSelected,
        columns,
        cleanSelected,
    };
};
